<template>
  <div>
    <div class="handle-search">
      <div class="search-box">
        <div class="searchItem">
            关系人：
            <el-select v-model="query.UserIds" multiple @change="getData">
                <el-option  v-for="item in AllAttachUser" :label="item.userAccount" :value="item.userId" :key="item.userId"></el-option>
            </el-select>
        </div>
        <div class="searchItem">
            争议状态：
            <el-select v-model="query.DisputeStatus" multiple @change="getData">
                <el-option  v-for="item in AllStatus" :value="item.Key" :label="item.Value" :key="item.Key"></el-option>
            </el-select>
        </div>
        <div class="searchItem">
            争议原因：
            <el-select v-model="query.DisputeReasons" multiple @change="getData">
                <el-option  v-for="item in AllReason" :value="item.Key" :label="item.Value" :key="item.Key"></el-option>
            </el-select>
        </div>
      </div>
    </div>
    <el-table
      :data="tableData"
      border
      class="table"
      ref="multipleTable"
      :height="tableHeight"
      :header-cell-style="{background:'#F3F4F7',color:'#555'}"
    >
      <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
      <el-table-column prop="disputeId" label="争议标识" width="160" align="center"></el-table-column>
      <el-table-column prop="disputeStatus" label="争议状态" align="center">
           <template slot-scope="scope">
               <div>
                    <span v-for="(item,index) in AllStatus" :key="index" v-if="scope.row.disputeStatus==item.Key">{{item.Value}}</span>
               </div>
           </template>
      </el-table-column>
      <el-table-column prop="disputeReason" label="争议原因" align="center">
          <template slot-scope="scope">
               <div>
                    <span v-for="(item,index) in AllReason" :key="index" v-if="scope.row.disputeReason==item.Key">{{item.Value}}</span>
               </div>
           </template>
      </el-table-column>
      <el-table-column prop="currencyCode" label="争议货币" align="center"></el-table-column>
      <el-table-column prop="currencyValue" label="争议金额" align="center"></el-table-column>
      <el-table-column prop="disputeCreateTime" label="争议发起时间" width="160" align="center"></el-table-column>
      <el-table-column prop="disputeLastUpdateTime" label="争议更新时间" width="160" align="center"></el-table-column>
      <el-table-column prop="userNickName" label="用户账号" align="center"></el-table-column>
      <el-table-column prop="sellerResponseDueDate" label="卖家回复截止时间" width="160" align="center"></el-table-column>
      <el-table-column prop="buyerResponseDueDate" label="买家回复截止时间" width="160" align="center"></el-table-column>
      <el-table-column prop="account" label="关联交易账号" width="140" align="center"></el-table-column>
      <el-table-column label="操作" align="center" width="200">
        <template slot-scope="scope">
          <div>
            <el-button type="primary" size="mini" @click="$router.push({
                path:'/orderDetail',
                query:{
                    id:scope.row.orderId
                }
            })">查看订单</el-button> 
            <el-button type="primary" size="mini"  @click="$router.push({
                path:'/disputeDetail',
                query:{
                    disputeId:scope.row.disputeId
                }
            })">查看争议</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageTotal"
        :page-sizes="[ 20,50,100,200]"
        @size-change="sizeChange"
        @current-change="handlePageChange"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import {
  GetCurDisputeAllReason,
  GetCurDisputeAllStatus,
  GetCurDisputeAllAttachUser,
  AllDisputes
} from "@/utils/api";
export default {
  data() {
    return {
      isAddData: false,
      tableData: [],
      form: {},
      pageTotal: 50,
      tableHeight: 0,
      AllReason:[],
      AllAttachUser:[],
      AllStatus:[],
      query: {
        Limit: 20,
        pageStart: 1,
        IsInOrder:true,
        UserIds:[],
        DisputeStatus:[],
        DisputeReasons:[]
      }
    };
  },
  methods: {
    getData() {
      AllDisputes(this.query).then(res => {
        if (res) {
          this.tableData = res.data;
          this.pageTotal = res.totalData;
        }
      });
    },
    initData(){
        GetCurDisputeAllReason().then(res=>{
            if(res){
                this.AllReason = res;
            }
        })
        GetCurDisputeAllStatus().then(res=>{
            if(res){
                this.AllStatus = res;
            }
        })
        GetCurDisputeAllAttachUser().then(res=>{
            if(res){
                this.AllAttachUser = res;
            }
        })
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, "pageStart", val);
      this.getData();
    },
    sizeChange(val) {
      this.$set(this.query, "Limit", val);
      this.getData();
    }
  },
  created() {
    this.getData();
    this.initData();
  },
  mounted() {
    this.$nextTick(() => {
      this.tableHeight =
        window.innerHeight - this.$refs.multipleTable.$el.offsetTop - 135;
    });
  }
};
</script>

<style lang="less" scoped>
.handle-search {
  background: #f3f3f3;
  border: 1px solid #ddd;
  padding: 10px 15px;
  margin-bottom: 20px;
  border-radius: 5px;
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
  align-items: center;
  .search-box {
    display: flex;
    display: -webkit-flex;
    .searchItem {
      margin-right: 20px;
    }
  }
}
.pagination {
  margin-top: 20px;
  text-align: center;
}
/deep/ .el-table__row {
  cursor: pointer;
}
</style>